import { Box, Grid, GridItem, useColorModeValue } from '@chakra-ui/react';
import { useEffect } from 'react';
import { useHelpContent } from '../../hooks/useHelpContent';
import HelpContent from './HelpContent';
import HelpSidebar from './HelpSidebar';

/**
 * Main Help page component
 * Displays help documentation with sidebar navigation
 */
const Help = () => {
  const bg = useColorModeValue('background.100', 'background.900');

  const {
    pageGuides,
    lexicon,
    filteredSections,
    searchQuery,
    setSearchQuery,
    activeSection,
    navigateToSection,
    getRelatedTerms,
    handleScroll,
  } = useHelpContent();

  // Add scroll listener to update active section
  useEffect(() => {
    let ticking = false;

    const onScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, [handleScroll]);

  return (
    <Box bg={bg} minH="100vh">
      <Grid
        templateColumns={{ base: '1fr', lg: '320px 1fr' }}
        gap="6"
        maxW="1400px"
        mx="auto"
      >
        {/* Sidebar */}
        <GridItem display={{ base: 'none', lg: 'block' }}>
          <HelpSidebar
            pageGuides={pageGuides}
            lexicon={lexicon}
            activeSection={activeSection}
            navigateToSection={navigateToSection}
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
          />
        </GridItem>

        {/* Main Content */}
        <GridItem>
          <HelpContent
            sections={filteredSections}
            navigateToSection={navigateToSection}
            getRelatedTerms={getRelatedTerms}
          />
        </GridItem>
      </Grid>
    </Box>
  );
};

export default Help;
